module.exports = __webpack_public_path__ + "img/Fr.c59d2cd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Fr.jpg
// module id = fkaV
// module chunks = 1